import React from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)
Theme(Highcharts)

const PieChartv2:  any = (props:any) => {
    // console.log(props.allData);
    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
    const {allData, exportExcel, labels,exportarImagen, title,subtitle, idChart, activeButton, colores,formatDataStringData,numDecimalProps,pieTextProps,showPieTextInGraph,showSeries} = props;

	const options = {
		chart: {
			backgroundColor: 'white',
			height: '500',
			colorCount: 15,
			zoomType: 'xy',
			// plotBackgroundColor: null,
			// plotBorderWidth: null,
			plotShadow: false,
			type: 'pie',
		},
		title: {
			text: title,

			style: {
				color: '#19355F',
				fontFamily: 'Montserrat-SemiBold',
				fontSize: '14px'


			}
		}
		, subtitle: {
			text: subtitle,
			style: {
				color: '#19355F',
				fontFamily: 'Montserrat-Medium',
				width: '80%',
				wordBreak: 'break-word'
			}
			
		}
		// , tooltip: {
		// 	pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
		// }
		, tooltip: {
			shared: true,
			useHTML: true,
			headerFormat: '<table><tr><th colspan="2">{point.key}:  <b>{point.y}%</b></th></tr>',
			pointFormat: '',
			footerFormat: '</table>',
			valueDecimals: 0
		}
		, accessibility: {
			point: {
				valueSuffix: '%'
			}
		},
		plotOptions: {
			pie: {
				dataLabels: {
					enabled: true,
					fontFamily: 'Montserrat-SemiBold',
					// @ts-ignore
					formatter: function() {
						// Usa 'this.point.color' para obtener el color del punto
						// @ts-ignore
						return '<span style="fontFamily: Montserrat-SemiBold; fontSize: 13px; color:' + this.point.color + '">'+this.point.name+'<br/>'+ + this.point.percentage.toFixed(0) + '%'  +'</span>';
					},
					distance: 10,
					filter: {
						property: 'percentage',
						operator: '>',
						value: 4
					}
				},
				allowPointSelect: true,
				cursor: 'pointer',
				showInLegend: true
			}
		},
		credits: {
			enabled: true,
			text: pieTextProps,
			style: {
			  fontSize: '12px',
			  fontFamily: 'Montserrat',
			  color: '#19355F'
			},
			position: {
			  align: 'right',
			  x: -10,
			  verticalAlign: 'bottom',
			  y: -5
			}
		  },
		// , series: allData
		 series: [{ innerSize: '70%', data: allData }]
		// 	[{
		// 		name: 'Si',
		// 		y: 95,
		// 		// sliced: true,
		// 		// selected: true
		// 	},  {
		// 		name: 'No ',
		// 		y: 5
		// 	}]
		// }]
		// , yAxis: {
		// 	title: "enabled"
		// 	, reversed: false,
		// 	labels:{
		// 		format: '{value}%'
		// 	}
		// }
		// , xAxis: {
		// 	categories : labels,
		// 	max: (labels.length - 1)
		// }
		, colors: colores
		, legend: {
			enabled: false,
			backgroundColor: '#FFFFFF',
			FontFamily: 'Montserrat-SemiBold',
			itemStyle: {
				color: '#19355F',
				fontFamily: 'Montserrat-SemiBold',
				fontSize: '11px',
			}
		},

		responsive: {  
			rules: [{  

			
			  condition: {  
				maxWidth: 1000
			  },  
			  chartOptions: {
			

				title: {		
					style: {
						color: '#19355F',
						fontFamily: 'Sans-Serif',
						fontSize: '14px'
					}
				},
                legend: {
                    align: 'center',
                    verticalAlign: 'bottom',
                    layout: 'horizontal',
					itemStyle: {
						color: '#19355F',
						fontFamily: 'Montserrat',
						fontSize: '8px',
					}
                },
				xAxis:{
					labels:{
						style:{
							fontSize: '8px',
						}
					}

				},
               
				subtitle: {
					style: {
						color: '#19355F',
						fontFamily: 'Montserrat',
						width: '80%',
						wordBreak: 'break-word',
						fontSize: '10px',

					}
					
				},
				plotOptions: {
					pie: {
						dataLabels: {
							fontFamily: 'Montserrat',
							fontWeight: 'bold',
							// @ts-ignore
							formatter: function() {
								// @ts-ignore
								return '<span style="fontFamily: Montserrat; fontSize: 13px; color:' + this.point.color + '">'+this.point.name+'<br/>'+ + this.point.percentage.toFixed(0) + '%'  +'</span>';
							},

						},
					}
				},
               
            }
			}]  
		  },
			
			lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",      
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
			},

			exporting: {
			enabled: activeButton, 
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportExcel({titulo: title, id: idChart});
					},
					text: 'Descargar XLSX'
				},
				descargarImagen: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportarImagen();
					},
					text: 'Descargar Imagen'
				},
			},
			
			buttons: {
				contextButton: {
					menuItems: [
						// "viewFullscreen",
						// "printChart",
						// "separator",
						"descargarImagen",
						"separator",
						"label"
					]
				}
			}
		},
	}

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}

export default PieChartv2;